import {Component, computed, inject, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {UserInvitationTemplateDialogService} from './user-invitation-template-dialog.service';
import {RichTextEditorComponent} from '../../../../../shared/components/rich-text-editor/rich-text-editor.component';
import {BaseDialogComponent} from '../../../../../shared/components/dialog/base-dialog/base-dialog.component';
import {USER_INVITATION_TEMPLATE_PREFIX} from '../project-user.service';

@Component({
  selector: 'app-user-invitation-template-dialog',
  templateUrl: './user-invitation-template-dialog.component.html',
  imports: [TranslocoPipe, RichTextEditorComponent, BaseDialogComponent],
})
export class UserInvitationTemplateDialogComponent {
  private readonly dialogService = inject(UserInvitationTemplateDialogService);

  readonly projectId = input.required<number>();

  get visible() {
    return this.dialogService.visible;
  }

  get initialContent() {
    return this.dialogService.templateContent();
  }

  get userRole(): string {
    return this.dialogService.selectedRole()?.translation ?? '';
  }

  get userRoleEnum(): string {
    return this.dialogService.selectedRole()?.enum ?? '';
  }

  readonly editorKey = computed(() => {
    return USER_INVITATION_TEMPLATE_PREFIX + this.userRoleEnum.toLowerCase();
  });

  saveEditorContent(content: string): void {
    this.dialogService.saveTemplateContent(this.projectId(), content);
  }

  close(): void {
    this.dialogService.closeDialog();
  }
}
